import React, { useState } from 'react';

const HabitsPage = () => {
  // Mock data - in a real app, this would come from an API or local storage
  const initialHabits = [
    {
      id: 1,
      name: 'Limit Social Media',
      target: '1 hour per day',
      progress: 70,
      streak: 5,
      status: 'active',
    },
    {
      id: 2,
      name: 'Take Screen Breaks',
      target: '5 breaks per day',
      progress: 60,
      streak: 3,
      status: 'active',
    },
    {
      id: 3,
      name: 'No Screens Before Bed',
      target: 'Stop at 10PM',
      progress: 90,
      streak: 7,
      status: 'active',
    },
    {
      id: 4,
      name: 'Focus Sessions',
      target: '2 sessions per day',
      progress: 50,
      streak: 2,
      status: 'active',
    },
    {
      id: 5,
      name: 'Digital-Free Weekends',
      target: '4 hours per weekend',
      progress: 30,
      streak: 1,
      status: 'active',
    },
  ];

  const [habits, setHabits] = useState(initialHabits);
  const [showNewHabitForm, setShowNewHabitForm] = useState(false);
  const [newHabit, setNewHabit] = useState({
    name: '',
    target: '',
  });

  const handleAddHabit = (e) => {
    e.preventDefault();
    
    if (newHabit.name.trim() === '' || newHabit.target.trim() === '') {
      return;
    }
    
    const habit = {
      id: habits.length + 1,
      name: newHabit.name,
      target: newHabit.target,
      progress: 0,
      streak: 0,
      status: 'active',
    };
    
    setHabits([...habits, habit]);
    setNewHabit({ name: '', target: '' });
    setShowNewHabitForm(false);
  };

  const toggleHabitStatus = (id) => {
    setHabits(
      habits.map((habit) =>
        habit.id === id
          ? { ...habit, status: habit.status === 'active' ? 'paused' : 'active' }
          : habit
      )
    );
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="md:flex md:items-center md:justify-between">
        <div>
          <h1 className="text-3xl font-display font-bold text-gray-900">Digital Habits</h1>
          <p className="mt-1 text-lg text-gray-500">
            Track and build healthy technology habits
          </p>
        </div>
        <div className="mt-4 md:mt-0">
          <button
            onClick={() => setShowNewHabitForm(true)}
            className="btn btn-primary flex items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
            Add New Habit
          </button>
        </div>
      </div>

      {showNewHabitForm && (
        <div className="mt-8 card">
          <h2 className="text-xl font-medium text-gray-900 mb-4">Create New Habit</h2>
          <form onSubmit={handleAddHabit}>
            <div className="grid gap-6 mb-6 md:grid-cols-2">
              <div>
                <label htmlFor="habit-name" className="block text-sm font-medium text-gray-700 mb-1">
                  Habit Name
                </label>
                <input
                  type="text"
                  id="habit-name"
                  className="input"
                  placeholder="e.g., Limit Social Media"
                  value={newHabit.name}
                  onChange={(e) => setNewHabit({ ...newHabit, name: e.target.value })}
                  required
                />
              </div>
              <div>
                <label htmlFor="habit-target" className="block text-sm font-medium text-gray-700 mb-1">
                  Target
                </label>
                <input
                  type="text"
                  id="habit-target"
                  className="input"
                  placeholder="e.g., 1 hour per day"
                  value={newHabit.target}
                  onChange={(e) => setNewHabit({ ...newHabit, target: e.target.value })}
                  required
                />
              </div>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                className="btn btn-outline"
                onClick={() => setShowNewHabitForm(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Create Habit
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {habits.map((habit) => (
          <div key={habit.id} className={`card ${habit.status === 'paused' ? 'opacity-70' : ''}`}>
            <div className="flex justify-between items-start">
              <h3 className="text-lg font-medium text-gray-900">{habit.name}</h3>
              <div className="relative">
                <button
                  className="text-gray-400 hover:text-gray-500 focus:outline-none"
                  onClick={() => toggleHabitStatus(habit.id)}
                >
                  {habit.status === 'active' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <p className="mt-1 text-sm text-gray-500">Target: {habit.target}</p>
            <div className="mt-4">
              <div className="flex justify-between text-sm text-gray-500 mb-1">
                <span>Progress</span>
                <span>{habit.progress}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${
                    habit.progress >= 80 ? 'bg-green-500' : habit.progress >= 40 ? 'bg-yellow-500' : 'bg-red-500'
                  }`}
                  style={{ width: `${habit.progress}%` }}
                ></div>
              </div>
            </div>
            <div className="mt-4 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <span className="ml-1 text-sm text-gray-500">{habit.streak} day streak</span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12">
        <h2 className="text-xl font-medium text-gray-900 mb-4">Habit Building Tips</h2>
        <div className="bg-blue-50 rounded-lg p-6">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-6 w-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-medium text-blue-800">Building Healthy Digital Habits</h3>
              <div className="mt-2 text-blue-700 space-y-1">
                <p>• Start small and be specific with your goals</p>
                <p>• Use the 2-minute rule: Make habits easy to start</p>
                <p>• Stack habits: Attach new habits to existing routines</p>
                <p>• Track your progress visually</p>
                <p>• Create an environment that supports your habits</p>
                <p>• Get an accountability partner</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HabitsPage; 